// @flow strict
import * as React from 'react';
import { Link } from 'gatsby';

import styles from './SidebarMenu.module.scss';
import categoryEmojiMap from '../../utils/emojiMap';

type Category = {
  slug: string,
  displayName: string,
  icon?: string,
};

export default ({ allCategories, slug }: { allCategories: ?Array<Category>, slug: string }) => (
  <div>
    <ul className={styles.sidebarList}>
      {allCategories &&
        allCategories.map(category => {
          const selected = category.slug === slug;
          return (
            <li key={`${category.slug}MenuItem`} className={selected ? styles.selected : ''}>
              <span className={styles.emoji} aria-hidden>
                {category.icon || categoryEmojiMap[category.slug] || categoryEmojiMap.default}
              </span>
              <Link to={`/${category.slug}`}>{category.displayName}</Link>
            </li>
          );
        })}
    </ul>
  </div>
);
